import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/financial-management/subscriptions`;

export const subscriptionRoutesObj = {
  list: baseRoute,
  settledPaymentView: `${baseRoute}/view/settled-payments/:subscriptionId`,
  cancelledPaymentView: `${baseRoute}/view/cancelled-payments/:subscriptionId`,
  pay: `${baseRoute}/pay/:subscriptionId`,
} as const;

export type ISubscriptionRouteParams = IExtractRouteParamMap<
  typeof subscriptionRoutesObj
>;

export const subscriptionPath = createPaths<
  typeof subscriptionRoutesObj,
  ISubscriptionRouteParams
>(subscriptionRoutesObj);
